<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-09 13:23:33
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-02-27 19:19:42
 * @Description: 开票主体
-->
<template>
  <div>
    <el-descriptions :colon="false" title="收票地址" :column="3">
      <el-descriptions-item label="收件人公司：">
        {{ detail.custReceiveCompany || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="邮箱地址：" :span="2">
        {{ detail.custReceiveEmail || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="收票地址：">
        {{ detail.receiveProvince }} {{ detail.receiveCity }}
        {{ detail.receiveArea }} {{ detail.receiveAddress }}
      </el-descriptions-item>
      <el-descriptions-item label="收票联系人：">
        {{ detail.receiveGoodsPerson || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="收票电话：">
        {{ detail.receiveGoodsPhone || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="快递公司：">
        {{ detail.logicCompanyName || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="快递单号：">
        <template v-if="detail.logicNumber">
          <a href="javascript:" @click="trackVisible = true">{{
            detail.logicNumber
          }}</a>
          <Copyable class="copyable" :text="detail.logicNumber"></Copyable>
        </template>
        <template v-else> - </template>
      </el-descriptions-item>
      <el-descriptions-item label="邮寄状态：">
        {{ detail.invoiceApplySubStatusText || '-' }}
      </el-descriptions-item>
    </el-descriptions>
    <!-- 查看轨迹 -->
    <el-dialog title="查看轨迹" :visible.sync="trackVisible" width="667px">
      <ViewTrack
        v-if="trackVisible"
        :logisticsCompanyName="detail.logicCompanyName"
        :logisticsCompanyCode="detail.logicCompanyCode"
        :logisticsNumber="detail.logicNumber"
        :phone="detail.receiveGoodsPhone"
      ></ViewTrack>
    </el-dialog>
  </div>
</template>

<script>
import Copyable from '@/components/copyable/index.vue'
import ViewTrack from '@/components/view-track/index'
export default {
  props: {
    detail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    Copyable,
    ViewTrack
  },
  data () {
    return {
      trackVisible: false
    }
  }
}
</script>

<style lang="scss" scoped></style>
